module.exports = __webpack_public_path__ + "bc39f302b91aa1145fe1462d8b80de4e.jpg";